import { render, staticRenderFns } from "./managedInstructionGroupName.vue?vue&type=template&id=656892d8"
import script from "./managedInstructionGroupName.vue?vue&type=script&lang=js"
export * from "./managedInstructionGroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports